module.exports = __webpack_public_path__ + "static/media/whatsapp.53d3e5a9.svg";